import { Fragment } from 'react';

type InlineCodeProps = {
  children: string;
};

// Splits a string on backtick-delimited segments and renders the odd
// segments as <code>. Unmatched trailing backticks are treated as literal
// text, so a stray "`" in copy never breaks the page.
export function InlineCode({ children }: InlineCodeProps) {
  const parts = children.split('`');
  const hasUnmatchedTrailing = parts.length % 2 === 0;

  return (
    <>
      {parts.map((part, index) => {
        const isCode = index % 2 === 1;
        const isUnmatchedTail = hasUnmatchedTrailing && index === parts.length - 1;
        if (isCode && !isUnmatchedTail) {
          return (
            <code key={index} className="inline-code">
              {part}
            </code>
          );
        }
        const literal = isUnmatchedTail ? '`' + part : part;
        return <Fragment key={index}>{literal}</Fragment>;
      })}
    </>
  );
}
